<button mat-raised-button (click)="isOptional = !isOptional">
  {{ !isOptional ? 'Enable optional steps' : 'Disable optional steps' }}
</button>

<mat-horizontal-stepper linear #stepper>
  <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="firstFormGroup">
      <ng-template matStepLabel>Fill out your name</ng-template>

      <!-- [cid]="service.cid"
      [service]="service"
      [field]="field"
      [form]="form"
      [stepperMode]="stepperMode"
      (showHideChanges)="showHideChanges($event)"
      [isEdit]="isEdit"
      [isClone]="isClone"
      [isSubmitted]="isSubmitted"
      (UpdateFormFieldValueEmitter)="UpdateFormFieldValue($event)"
      [fxFlex.gt-lg]="getInputGridSize(field?.form?.grid?.gt_lg, gridGapSize)"
      [fxFlex.lt-xl]="getInputGridSize(field?.form?.grid?.lt_xl, gridGapSize)"
      [fxFlex.lt-lg]="getInputGridSize(field?.form?.grid?.lt_lg, gridGapSize)"
      [fxFlex.lt-md]="getInputGridSize(field?.form?.grid?.lt_md, gridGapSize)"
      [fxFlex.lt-sm]="getInputGridSize(field?.form?.grid?.lt_sm, gridGapSize)" -->

      <mat-form-field>
        <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required />
      </mat-form-field>
      <div>
        <button mat-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="secondFormGroup" [optional]="isOptional">
    <form [formGroup]="secondFormGroup">
      <ng-template matStepLabel>Fill out your address</ng-template>
      <mat-form-field>
        <input matInput placeholder="Address" formControlName="secondCtrl" required />
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious>Back</button>
        <button mat-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Done</ng-template>
    You are now done.
    <div>
      <button mat-button matStepperPrevious>Back</button>
      <button mat-button (click)="stepper.reset()">Reset</button>
    </div>
  </mat-step>
</mat-horizontal-stepper>
